// extracted by mini-css-extract-plugin
module.exports = {"component":"booking-overview_component__7LHgD","column":"booking-overview_column__8orMz"};